import { render } from "./bill-list-staff.vue?vue&type=template&id=8f2f3380&ts=true"
import script from "./bill-list-staff.vue?vue&type=script&lang=ts"
export * from "./bill-list-staff.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__